export default "__VITE_ASSET__CQGB8i7D__"